import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { CongViec } from "../models/congviec/CongViec";
import intance from "../utils/axios";

export const timKiemCongViec = async (tuKhoa: string, tuNgay: string, denNgay: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.congViec.layDsCongViec, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa,
            "tuNgay": tuNgay,
            "denNgay": denNgay
        }
    })
    .then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    })
    .catch((err) => {
        throw err;
    });
    return data;
};

export const luuCongViec = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.congViec.luuCongViec, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
};

export const layCTCongViec = async (id: number) => {
    var data = new CongViec;
    await intance.get(ApiPaths.congViec.LayCT + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw res.data.thongBao
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsCongViecTheoNvKhoiTao = async () => {
    var data :any;
    await intance.get(ApiPaths.congViec.layDsCongViecTheoNvKhoiTao)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw res.data.thongBao
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}
